import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map'
import { AuthHttp } from 'angular2-jwt';

import { ReservationModel } from './../../models';

@Injectable()
export class ReservationService {
    constructor(private http: AuthHttp) {

    }

    getAll(): Observable<ReservationModel[]> {
        return this.http.get('api/reservation').map((r: Response) => r.json());
    }

    create(reservation: ReservationModel) {
        return this.http.post('api/reservation', JSON.stringify(reservation), { headers: new Headers({ 'Content-Type': 'application/json' }) });
    }

    update(id: string, reservation: ReservationModel) {
        return this.http.put('api/reservation/'+id, JSON.stringify(reservation), { headers: new Headers({ 'Content-Type': 'application/json' }) });
    }

    delete(id: string) {
        return this.http.delete('api/reservation/'+id);
    }
}


// WEBPACK FOOTER //
// C:/Users/Willi/Source/Repos/Reservation01/scr/reservation.client/src/app/services/reservation-service/reservation.service.ts